export function getFullNameInitials(name: string) {
  const nameList = name.split(' ');
  const firstNameInitial = nameList[0][0]?.toUpperCase();
  const lastNameInitial = nameList[nameList.length - 1][0]
    ? nameList[nameList.length - 1][0]?.toUpperCase()
    : '';

  return `${firstNameInitial}${lastNameInitial}`;
}
